import React, {useState} from "react";
import Typography from "@mui/material/Typography";
import {Paper} from "components/atoms/Paper/Paper";
import {Link} from "@mui/material";

export const ResultsDisclaimer = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
      <Paper variant="light2">
        <Typography variant="h5">About the results you see on this Web site</Typography>
        <Typography component="p" sx={{mt:2}}>Past results are not necessarily indicative of future results. Therefore, you should not assume that the future performance of any specific investment or investment strategy will be profitable or equal to the corresponding past performance.</Typography>
        <Typography component="p" sx={{mt:2}}>The value of an investment can go down as well as up and you may get back less than you invested. If you are not sure about investing, seek independent advice.</Typography>
      </Paper>
  )
}